import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  buttonCol: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));
